import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { getCookie } from "../EnhancedComponentOL/utils";

export default function Events(props) {
  const [events, setEvents] = useState([]);
  const [count, setCount] = useState(0);
  const [userDetail, setUserDetails] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.post("/Events.php");
        const eventData = response.data.phpresult || [];
        setEvents(eventData);
        setCount(eventData.length);

        const its = getCookie("ITS_ID");
        const userResponse = await axios.post("/UserDetails.php", { ITS: its });
        setUserDetails(userResponse.data.phpresult || {});
        console.log(events);
        console.log(eventData);
      } catch (error) {
        console.error("Error fetching events:", error);
      }
    };
    fetchData();
  }, []);

  const renderEventCards = (event) => {
    return (
      <>
        {/* Audio + Video Card */}
        <div className="col-xl-4 col-sm-6 mb-3" key={`${event.Id}-AudioVideo`}>
          <div className="channels-card">
            <div className="channels-card-body">
              <div className="channels-title">
                <span
                  style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}
                >
                  {event.Name} (Audio + Video)
                </span>
              </div>
              <div className="channels-view">
                <span
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "GrayText",
                  }}
                >
                  {event.Details}
                </span>
              </div>
              <br />
              <div className="channels-card-image">
                <Link to={`/SingleVideo?EventId=${event.Id}&mode=AudioVideo`}>
                  <div className="channels-card-image-btn">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{ width: "80%", padding: "10px" }}
                    >
                      Watch Audio + Video
                    </button>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>

        {/* Audio Only Card */}
        <div className="col-xl-4 col-sm-6 mb-3" key={`${event.Id}-Audio`}>
          <div className="channels-card">
            <div className="channels-card-body">
              <div className="channels-title">
                <span
                  style={{ fontSize: "24px", fontWeight: "bold", color: "red" }}
                >
                  {event.Name} (Audio Only)
                </span>
              </div>
              <div className="channels-view">
                <span
                  style={{
                    fontSize: "15px",
                    fontWeight: "bold",
                    color: "GrayText",
                  }}
                >
                  {event.Details}
                </span>
              </div>
              <br />
              <div className="channels-card-image">
                <Link to={`/SingleVideo?EventId=${event.Id}&mode=Audio`}>
                  <div className="channels-card-image-btn">
                    <button
                      type="button"
                      className="btn btn-outline-danger"
                      style={{ width: "80%", padding: "10px" }}
                    >
                      Listen to Audio
                    </button>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div id="wrapper">
      <div id="content-wrapper">
        <div className="container-fluid pb-0">
          <div className="top-category section-padding mb-4">
            <div className="row">
              <div className="col-md-12">
                <div className="main-title">
                  <div
                    className="btn-group float-right right-action"
                    style={{ color: "white", fontWeight: "bolder" }}
                  >
                    Name: {userDetail?.Name || ""}
                    <br />
                    Area/Jamaat: {userDetail?.Area || ""}
                    <br />
                    Device: {userDetail?.device_info || ""}
                  </div>
                  <h6 style={{ color: "white" }}>Haidery Masjid - Bhopal</h6>
                </div>
              </div>
            </div>
          </div>

          <div className="video-block section-padding">
            <div className="row">
              <div className="col-md-12">
                <div className="main-title">
                  {count > 0 ? (
                    <h6 style={{ color: "white" }}>Active Events</h6>
                  ) : (
                    <h6 style={{ color: "white" }}>
                      Currently No Live Events Found
                    </h6>
                  )}
                </div>
              </div>

              {events.map((event) => renderEventCards(event))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
